import { createXKey } from './utils';
import { ElementSelect } from './elementSelect';
export function ElementSelectByX(options) {
    return ElementSelect(Object.assign(Object.assign({}, options), { createGroup: createXKey }));
}
ElementSelectByX.props = {
    reapplyWhenUpdate: true,
};
//# sourceMappingURL=elementSelectByX.js.map